import {HttpClient, HttpClientModule, provideHttpClient, withFetch} from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ServiceWorkerModule } from '@angular/service-worker';
import { DecimalPipe, DatePipe } from '@angular/common';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader} from '@ngx-translate/http-loader';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '@env/environment';

import { CoreModule, AuthenticationGuard } from '@app/core';
import { AirlineGuard } from '@app/core/guards/airline.guard';
import { PremiumGuard } from '@app/core/guards/premium.guard';
import { HttpService } from '@app/core/http/http.service';
import { AppComponent } from '@app/app.component';
import { AppRoutingModule } from '@app/app-routing.module';
import { LandingModule } from '@app/landing/landing.module';
import { HttpErrorHandler } from '@app/core/http-error-handler.service';
import { MessageService } from '@app/core/message.service';
import { ChartsModule } from '@app/charts/charts.module';
import { PaymentManagementModule } from '@app/payment-management/payment-management.module';
import { ServicesModule } from '@app/services/services.module';
import { SharedModule } from '@app/shared/shared.module';
import { MacroGroupsModule } from '@app/macro-groups/macro-groups.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { ContractManagementModule } from './contracts-management/contracts-management.module';
import { Router } from '@angular/router';
import { AdministrationCleanupModule } from "@app/administration/cleanup-management/administration-cleanup.module";

import { providePrimeNG } from "primeng/config";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";

import Aura from '@primeng/themes/aura';
import Material from '@primeng/themes/material';
import Lara from '@primeng/themes/lara';
import Nora from '@primeng/themes/nora';

const directives: any[] = [
  HttpService,
  HttpErrorHandler,
  MessageService,
  AuthenticationGuard,
  AirlineGuard,
  PremiumGuard,
  DecimalPipe,
  DatePipe,
  provideHttpClient(withFetch()),
  provideAnimationsAsync(),
  providePrimeNG({
    ripple: false,
    inputStyle: 'filled', //outlined ot filled
    inputVariant: 'filled', //outlined ot filled
    theme: {
      preset: Lara,
      options: {
        darkModeSelector: false,
        cssLayer: {
          name: 'bootstrap',
          order: 'bootstrap, primeng'
        },
      }
    },
    // theme: {
    //   options: {
    //     prefix: 'my',
    //     inputStyle: 'filled', // Override input style
    //     buttonStyle: 'filled', // Override button style
    //     menuStyle: 'overlay', // Override menu style
    //     ripple: false, // Ensure ripple is disabled
    //   }
    // },
    zIndex: {
      modal: 1100,    // dialog, sidebar
      overlay: 1000,  // dropdown, overlaypanel
      menu: 1000,     // overlay menus
      tooltip: 1100   // tooltip
    }
  })
];

@NgModule({
  imports: [
    BrowserModule,
    ServiceWorkerModule.register('./ngsw-worker.js', { enabled: environment.production }),
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
    }),
    NgbModule,
    CoreModule,
    SharedModule,
    LandingModule,
    ChartsModule,
    PaymentManagementModule,
    AppRoutingModule,
    ServicesModule,
    BrowserAnimationsModule,
    NgSelectModule,
    MacroGroupsModule,
    ContractManagementModule,
    AdministrationCleanupModule
  ],
  declarations: [
    AppComponent
  ],
  providers: directives,
  bootstrap: [
    AppComponent
  ]
})
export class AppModule {
  constructor(
    private readonly router: Router
  ) {
    router.events
      .subscribe(console.log);
  }
}

export function HttpLoaderFactory(http: HttpClient) {
  if(environment.production){
    return new TranslateHttpLoader(http, environment.prefix);
  }
  // En caso de ser desarrollo, no hace falta el prefijo para los ficheros de traducción
  return new TranslateHttpLoader(http);
}
